import { render, staticRenderFns } from "./SmsPattern.vue?vue&type=template&id=d67c6644&scoped=true"
import script from "./SmsPattern.vue?vue&type=script&lang=js"
export * from "./SmsPattern.vue?vue&type=script&lang=js"
import style0 from "./SmsPattern.vue?vue&type=style&index=0&id=d67c6644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67c6644",
  null
  
)

export default component.exports